import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { usePaymentOptionContext } from "checkout-experience/components/payment-method/payment-option-provider";

const LpmFooter = () => {
  const { t } = useTranslation();
  const { paymentOption } = usePaymentOptionContext() ?? {};
  const { paymentType } = paymentOption ?? {};

  return (
    <Text styleVariant={"body"}>
      {t("lpmInstructionsWithLpm", { lpm: t(paymentType ?? "") })}
    </Text>
  );
};

export default LpmFooter;
